import Text, { Ecolor } from '../text';
import classes from './style.module.scss';
interface Iprops {
  name: string;
  label: string;
  value: string | number;
  data: Array<{ label: string; value: string | number }>;
  onChange?: (v: string | number) => void;
  allignment?: 'horizontal' | 'vertical';
  required?: boolean;
}
const RadioButton = ({
  name,
  label,
  value = '',
  data,
  onChange,
  required,
  allignment = 'horizontal',
}: Iprops) => {
  return (
    <div>
      <Text color={Ecolor.deep} required={required}>
        {label}
      </Text>
      {allignment === 'horizontal' ? (
        <div className="flex items-center gap-4">
          {data.map((radio, i) => (
            <span
              className={
                value === radio.value
                  ? `${classes.radio} ${classes.active}`
                  : classes.radio
              }
              key={`${name}-${i}`}
              onClick={(e) => {
                onChange?.(radio.value);
              }}
            >
              <span className={classes.dot}></span>
              <Text color={Ecolor.deep} style={{ marginBottom: 0 }}>
                {radio.label}
              </Text>
            </span>
          ))}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};
export default RadioButton;
